import React, { FC } from "react";
import { Whisper, Tooltip } from "rsuite";

import "./index.scss";
import { Icon } from "../Icon";

export type TQuality = 0 | 1 | 3 | 5;

export interface QualitySignalProps {
  quality: TQuality;
  text: string;
}

const getActiveColor = (quality: TQuality): string => {
  switch (quality) {
    case 0: {
      return "#869CAC";
    }
    case 1:
      return "#926E04";
    case 3:
      return "#FF8A00";
    case 5:
      return "#35C09F";
    default:
      return "#FF0000";
  }
};

const QualitySignalText = {
  0: "No connection",
  1: "Poor connectionr",
  3: "Good connection",
  5: "Excellent connection",
};

const QualitySignal: FC<QualitySignalProps> = ({ text, quality }) => {
  const activeColor = getActiveColor(quality);

  return (
    <Whisper
      trigger="hover"
      placement="bottom"
      controlId="qualitySignal"
      speaker={<Tooltip>{QualitySignalText[quality]}</Tooltip>}
    >
      <div className="quality-signal-wrapper">
        <div className="quality-signal">
          {quality ? (
            <>
              <QualitySignalColumn level={1} quality={quality} activeColor={activeColor} height="15%" />
              <QualitySignalColumn level={2} quality={quality} activeColor={activeColor} height="32.5%" />
              <QualitySignalColumn level={3} quality={quality} activeColor={activeColor} height="54.5%" />
              <QualitySignalColumn level={4} quality={quality} activeColor={activeColor} height="75.6%" />
              <QualitySignalColumn level={5} quality={quality} activeColor={activeColor} height="100%" />
            </>
          ) : (
            <Icon className="no-signal" type="no-signal" />
          )}
        </div>
        <div className="quality-signal-text" style={{ color: activeColor }}>
          {text}
        </div>
      </div>
    </Whisper>
  );
};

export default QualitySignal;

interface QualitySignalColumnProps {
  level: number;
  quality: TQuality;
  height: string;
  activeColor?: string;
}

const QualitySignalColumn: FC<QualitySignalColumnProps> = ({ quality, level, height, activeColor }) => {
  const backgroundColor = quality >= level ? activeColor : undefined;

  return <div className="quality-signal-row" style={{ height, background: backgroundColor }} />;
};
